import { createAsyncThunk } from '@reduxjs/toolkit';
import employeeServiceApiInstance from '../../../../config/employeeApiConfig';
import { GoalList , GoalListState, updateGoallist } from './goallistTypes';

export const createGoallist = createAsyncThunk(
    'performance/createGoallist',
    async (data: GoalList, { rejectWithValue }) => {
      try {  
        const response = await employeeServiceApiInstance.post('/performance/goallist', data);          
        return response.data;
      } catch (error: any) {
        return rejectWithValue(error.response?.data || 'Failed to create Goallist');
      }
    }
  ); 


  export const UpdateGoallist = createAsyncThunk<any , {goallistId: number; data: any}, { rejectValue: string }>(
    'performance/updateGoallist',
    async ({goallistId, data}: {goallistId: Number; data: Partial<updateGoallist>}, { rejectWithValue }) => {
      try {  
        const response = await employeeServiceApiInstance.put(`/performance/goallist/${goallistId}`, data)
        return response.data;
      } catch (error: any) {
        return rejectWithValue(error.response?.data || 'Failed to create Goallist');
      }
    }
  ); 
  export const UpdateGoallistbyemployee = createAsyncThunk<any , {goallistId: number; data: any}, { rejectValue: string }>(
    'performance/updateGoallist',
    async ({goallistId, data}: {goallistId: Number; data: Partial<updateGoallist>}, { rejectWithValue }) => {
      try {  
        const response = await employeeServiceApiInstance.put(`/performance/goallist/updatebyemployee/${goallistId}`, data)
        return response.data;
      } catch (error: any) {
        return rejectWithValue(error.response?.data || 'Failed to update Goallist');
      }
    }
  ); 


  export const deleteGoallist = createAsyncThunk(
    'performance/deleteGoallist',
    async (goallistId: number, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.delete(`/performance/goallist/${goallistId}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to delete Goallist');
        }
    }
);

export const fetchGoallistById = createAsyncThunk(
    'performance/fetchGoallistById',
    async (goallistId: number, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/performance/goallist/${goallistId}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch Goallist');
        }
    }
);

export const fetchAllGoallist = createAsyncThunk(
    'performance/fetchAllGoallist',
    async (_, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get('/performance/goallist');
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch all Goallist');
        }
    }
);

export const fetchAllGoallistbyemployeeId = createAsyncThunk(
  'performance/fetchAllGoallistemployeeId',
  async ( id : any, { rejectWithValue }) => {
      try {
          const response = await employeeServiceApiInstance.get(`/performance/goallist/goallistbyemployeeId/${id}`);
          return response.data;
      } catch (error: any) {
          return rejectWithValue(error.response?.data || 'Failed to fetch all Goallist');
      }
  }
);
